module.exports = __webpack_public_path__ + "static/media/newsletter.826f82e4.svg";